import {
  type CommandProperties,
  createCommand,
} from '@atlassian/rovo-content-bridge-api';

export type ForwardedKeyboardEventProperties = {
  key: string;
  code: string;
  ctrlKey: boolean;
  shiftKey: boolean;
  altKey: boolean;
  metaKey: boolean;
  isInteractiveDbElement?: boolean;
};

export type KeyboardDownCommandProperties = CommandProperties &
  ForwardedKeyboardEventProperties;

export type KeyboardUpCommandProperties = CommandProperties &
  ForwardedKeyboardEventProperties;

export const KeyboardDownCommand =
  createCommand<KeyboardDownCommandProperties>('keyboard-down');

export const KeyboardUpCommand =
  createCommand<KeyboardUpCommandProperties>('keyboard-up');
